import React, { Component } from 'react'
import Classes from './style.module.css'
export default class Thousandtwo extends Component {
    constructor(props) {
        super(props)
        const getValues = () => {
            var values = this.props.filterData
            if (!values) {
                return []
            }
            if (typeof values !== 'string') {
                return Array.isArray(values) ? values : []
            }
            if (values.includes(',')) {
                return values.split(',')
            }
            return [values]
        }
        this.state = {
            defVal: this.props.defdata,
            value: getValues()
        }
    }
    componentDidUpdate(preProps) {
        if (preProps.filterData != this.props.filterData) {
            const getdefValues = (data) => {
                if (!data) {
                    return []
                }
                if (typeof data !== 'string') {
                    return Array.isArray(data) ? data : []
                }
                if (data.includes(',')) {
                    return data.split(',')
                }
                return [data]
            }
            this.setState({ value: getdefValues(this.props.filterData), defVal: this.props.defdata })
        }
    }
    storeValue(e) {
        this.setState({ defVal: e.target.value })
        this.props.onChange(e.target.value)
    }
    render() {
        const getID = (val) => {
            if (val.indexOf(' ') > -1) {
                return val.replace(' ', '') + (new Date()).getTime()
            } else {
                return val + (new Date()).getTime()
            }
        }
        return (
            <div className={Classes.overflow} style={{ maxHeight: "370px", overflow: "auto" }}>
                {
                    this.state.value.length === 0 ? (
                        <div style={{ color: "#888", padding: "8px 0" }}>No options available</div>
                    ) : (
                        this.state.value.map((val, index) => {
                            var check = val == this.state.defVal
                            return (
                                <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "5px" }}>
                                    <input type="radio" id={getID(val)} name={val} value={val} onChange={(e) => this.storeValue(e)} checked={check} style={{ width: "20px", height: "20px" }} />
                                    <label htmlFor={getID(val)} style={{ paddingLeft: "10px", cursor: 'pointer' }}>{val}</label>
                                </div>
                            )
                        })
                    )
                }
            </div>
        )
    }
}